import 'whatwg-fetch'

import ManagedError from '../../domain/ManagedError';

class FetchExecutor {

  constructor(httpResponseHandler) {

    this.httpResponseHandler = httpResponseHandler;

  }

  executeFetchRequest(url, fetchRequest) {

    let responseContent = {
      url: url
    };

    return fetch(url, fetchRequest)
      .then((response) => {

        responseContent.status = response.status;
        return response;

      })
      .then((response) => response.text())
      .then((bodyText) => {

        try {
          return JSON.parse(bodyText);
        } catch(ex) {
          return bodyText;
        }

      })
      .then((data) => {

        responseContent.body = data;
        return this.httpResponseHandler.extractResponseFromRequest(responseContent);

      })
      .catch((ex) => {

        if (ex instanceof ManagedError) {
          throw ex;
        }
        this.httpResponseHandler.handleHttpError(ex);

      });

  };

}

export default FetchExecutor;



// WEBPACK FOOTER //
// ./src/library/services/http/FetchExecutor.js